"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AttributesList = void 0;
var _react = _interopRequireDefault(require("react"));
var _key = require("b2b-components/utils/key");
var _classnames = _interopRequireDefault(require("classnames"));
var _AttributesList = require("./AttributesList.types");
require("./AttributesList.scss");
const AttributesList = _ref => {
  let {
    variant = _AttributesList.ATTRIBUTES_LIST_VARIANT.pipe,
    attributes,
    withPadding,
    className,
    sku
  } = _ref;
  const rootClassName = (0, _classnames.default)('cds-List', 'cds-AttributesList', {
    'cds-List--Piped': variant === _AttributesList.ATTRIBUTES_LIST_VARIANT.pipe,
    'cds-List--Bulleted': variant === _AttributesList.ATTRIBUTES_LIST_VARIANT.bullet,
    'cds-AttributesList--WithPadding': withPadding
  }, className);
  return /*#__PURE__*/_react.default.createElement("ul", {
    className: rootClassName
  }, Array.isArray(attributes) && attributes.map(item => /*#__PURE__*/_react.default.createElement("li", {
    key: `sku-${sku}-${(0, _key.createKey)(item)}-${item.slice(0, Math.floor(Math.random() * (item.length - 1) + 1))}`
  }, item)));
};
exports.AttributesList = AttributesList;
//# sourceMappingURL=AttributesList.js.map